import { render, staticRenderFns } from "./indexkf.vue?vue&type=template&id=e2d0b010"
import script from "./indexkf.vue?vue&type=script&lang=js"
export * from "./indexkf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports